import React, {useState} from "react";
import {useFormik} from "formik";
import InputLabel from '@material-ui/core/InputLabel';
import {Card, CardBody} from "../../../../_metronic/_partials/controls";
import CardHeader from "@material-ui/core/CardHeader";
import {useSelector} from "react-redux";
import {fetchUser, updateUserInformation} from "../AdminPagesCrud";
import {useParams} from "react-router-dom";
import Input from "@material-ui/core/Input";
import MaskedInput from "react-text-mask";
import PropTypes from "prop-types";
import * as Yup from "yup";
import {injectIntl} from "react-intl";
import FilledInput from "@material-ui/core/FilledInput";
import Select from "@material-ui/core/Select";
import UserAdminPage from "./UserAdminPage";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import Grid from "@material-ui/core/Grid";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";

function TextMaskCustom(props) {
    const { inputRef, ...other } = props;

    return (
        <MaskedInput
            {...other}
            ref={(ref) => {
                inputRef(ref ? ref.inputElement : null);
            }}
            mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
            placeholderChar={'\u2000'}
            showMask
        />
    );
}

TextMaskCustom.propTypes = {
    inputRef: PropTypes.func.isRequired,
};




function EditOrAddUser({ selectedUser, setOpenUserForm, tenantSuppliers, supplierClients, setShowSnackbar, showSnackbar, intl}) {

    const {id} = useParams();
    const [cancel, setCancel] = useState(false);
    const [country, setCountry] = useState('Puerto Rico');
    const [user, setUser] = useState(selectedUser);
    const [physicalCity, setPhysicalCity] = useState(user.physicalCity);
    const [postalCity, setPostalCity] = useState(user.postalCity);
    const [active, setActive] = useState(user.active);
    const [verified, setVerified] = useState(user.emailVerified);

    const {accessToken} = useSelector (
        ({auth}) =>({
            accessToken: auth.authToken,
        })
    )

    const userInformationSchema = Yup.object().shape({
        fullName: Yup.string()
            .min(3, "Minimum 3 symbols")
            .max(50, "Maximum 50 symbols")
            .required(
                intl.formatMessage({
                    id: "AUTH.VALIDATION.REQUIRED_FIELD",
                })
            ),
        phoneNumber: Yup.string()
            .min(3, "Minimum 3 symbols")
            .max(500, "Maximum 500 symbols")
            .required(
                intl.formatMessage({
                    id: "AUTH.VALIDATION.REQUIRED_FIELD",
                })
            ),
        email: Yup.string()
            .min(3, "Minimum 3 symbols")
            .max(50, "Maximum 50 symbols")
            .required(
                intl.formatMessage({
                    id: "AUTH.VALIDATION.REQUIRED_FIELD",
                })
            ),
        accountType: Yup.string()
            .min(3, "Minimum 3 symbols")
            .max(50, "Maximum 50 symbols")
            .required(
                intl.formatMessage({
                    id: "AUTH.VALIDATION.REQUIRED_FIELD",
                })
            ),
    });


    const userFormik = useFormik({
        initialValues: user,
        validationSchema: userInformationSchema,
        onSubmit: (values, { setStatus, setSubmitting }) => {
            try {
                console.log("Submit values: ", values)
                updateUserInformation(selectedUser._id, values, accessToken).then((response) => {
                    setShowSnackbar(!showSnackbar);
                    setOpenUserForm(false);
                })
            } catch (e) {
                alert("An error occurred");
                console.log(e.message);
            }
        }
    });


    return (
        <>
            <Card>
                <CardHeader title="Edit User"/>
                <CardBody>
                    <form onSubmit={userFormik.handleSubmit}>
                        <div>
                            <div className="">
                                <div className="col-12">
                                    <Grid container>
                                        <Grid container spacing={2}>
                                            <Grid item xs={6}>
                                                <div className="form-group fv-plugins-icon-container">
                                                    <InputLabel>Full Name</InputLabel>
                                                    <input
                                                        type="text"
                                                        className={`form-control form-control-solid h-auto py-2 px-6`}
                                                        name="entityName"
                                                        disabled
                                                        {...userFormik.getFieldProps("fullName")}
                                                    />
                                                    {userFormik.touched.fullName && userFormik.errors.fullName ? (
                                                        <div className="fv-plugins-message-container">
                                                            <div
                                                                className="fv-help-block">{userFormik.errors.fullName}</div>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <div className="form-group fv-plugins-icon-container">
                                                    <InputLabel>Phone Number</InputLabel>
                                                    <Input
                                                        type="text"
                                                        className={`form-control form-control-solid h-auto py-2 px-6`}
                                                        name="phoneNumber"
                                                        disabled
                                                        // inputComponent={TextMaskCustom}
                                                        {...userFormik.getFieldProps("phoneNumber")}
                                                    />
                                                    {userFormik.touched.phoneNumber && userFormik.errors.phoneNumber ? (
                                                        <div className="fv-plugins-message-container">
                                                            <div
                                                                className="fv-help-block">{userFormik.errors.phoneNumber}</div>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <div className="form-group fv-plugins-icon-container">
                                                    <InputLabel>Email</InputLabel>
                                                    <input
                                                        type="text"
                                                        className={`form-control form-control-solid h-auto py-2 px-6`}
                                                        name="email"
                                                        disabled
                                                        {...userFormik.getFieldProps("email")}
                                                    />
                                                    {userFormik.touched.email && userFormik.errors.email ? (
                                                        <div className="fv-plugins-message-container">
                                                            <div
                                                                className="fv-help-block">{userFormik.errors.email}</div>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <div className="form-group fv-plugins-icon-container">
                                                    {/*<div className="form-group fv-plugins-icon-container">*/}
                                                    <FormControl variant="filled" className={'w-100'}>
                                                        <InputLabel >Account Type</InputLabel>
                                                        <Select
                                                            input={<FilledInput name="accountType" id="accountType"
                                                                                type="select"
                                                                                defaultValue={user.accountType}
                                                                                disabled
                                                                                className={`form-control form-control-solid h-auto py-2 px-6`}
                                                                                {...userFormik.getFieldProps("accountType")}
                                                            />}
                                                        >
                                                            <MenuItem value={"buyer"}>Buyer</MenuItem>
                                                            <MenuItem value={"supplier"}>Supplier</MenuItem>
                                                            <MenuItem value={"admin"}>Admin</MenuItem>

                                                        </Select>
                                                        {userFormik.touched.accountType && userFormik.errors.accountType ? (
                                                            <div className="fv-plugins-message-container">
                                                                <div className="fv-help-block">{userFormik.errors.accountType}</div>
                                                            </div>
                                                        ) : null}
                                                    </FormControl>
                                                </div>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <div className="form-group fv-plugins-icon-container">
                                                    <InputLabel>Roles</InputLabel>
                                                    <input
                                                        type="text"
                                                        className={`form-control form-control-solid h-auto py-2 px-6`}
                                                        name="roles"
                                                        disabled
                                                        {...userFormik.getFieldProps("roles")}
                                                    />
                                                    {userFormik.touched.roles && userFormik.errors.roles ? (
                                                        <div className="fv-plugins-message-container">
                                                            <div
                                                                className="fv-help-block">{userFormik.errors.roles}</div>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <div className="form-group fv-plugins-icon-container">
                                                    <InputLabel >Is Active</InputLabel>
                                                    <Select
                                                        input={<FilledInput name="active" id="active"
                                                                            type="text"
                                                                            disabled
                                                                            className={`form-control form-control-solid h-2 py-2 px-6`}
                                                                            {...userFormik.getFieldProps("active")}
                                                        />}
                                                    >
                                                        <MenuItem value={true}>Yes</MenuItem>
                                                        <MenuItem value={false}>No</MenuItem>

                                                    </Select>
                                                    {userFormik.touched.active && userFormik.errors.active ? (
                                                        <div className="fv-plugins-message-container">
                                                            <div className="fv-help-block">{userFormik.errors.active}</div>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <div className="form-group fv-plugins-icon-container">
                                                    <InputLabel >Assign Stores</InputLabel>
                                                    <Autocomplete
                                                        multiple
                                                        options={supplierClients}
                                                        getOptionLabel={(option) => option.businessName || ''}
                                                        renderTags={(value, getTagProps) =>
                                                            value.map((option) => option.businessName).join(", ")
                                                        }
                                                        value={supplierClients.filter(client =>
                                                            (userFormik.values.exclusiveStoreIds || []).includes(client._id.toString())
                                                        )}
                                                        onChange={(e, newValue) => {
                                                            userFormik.setFieldValue(
                                                                "exclusiveStoreIds",
                                                                newValue.map(client => client._id.toString())
                                                            );
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                variant="filled"
                                                                name="exclusiveStoreIds"
                                                                placeholder="Search stores..."
                                                                InputProps={{
                                                                    ...params.InputProps,
                                                                    disableUnderline: false,
                                                                    style: { backgroundColor: '#F3F6F9' }
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                </div>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <div className="form-group fv-plugins-icon-container">
                                                    <InputLabel >Assign Suppliers</InputLabel>
                                                    <Autocomplete
                                                        multiple
                                                        options={tenantSuppliers}
                                                        getOptionLabel={(option) => option.entityName || ''}
                                                        renderTags={(value, getTagProps) =>
                                                            value.map((option) => option.entityName).join(", ")
                                                        }
                                                        value={tenantSuppliers.filter(supplier =>
                                                            (userFormik.values.exclusiveSupplierIds || []).includes(supplier._id.toString())
                                                        )}
                                                        onChange={(e, newValue) => {
                                                            userFormik.setFieldValue(
                                                                "exclusiveSupplierIds",
                                                                newValue.map(supplier => supplier._id.toString())
                                                            );
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                variant="filled"
                                                                name="exclusiveSupplierIds"
                                                                placeholder="Search suppliers..."
                                                                InputProps={{
                                                                    ...params.InputProps,
                                                                    disableUnderline: false,
                                                                    style: { backgroundColor: '#F3F6F9' }
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                </div>
                                            </Grid>
                                            
                                            {/* <Grid item xs={6}>
                                                <div className="form-group fv-plugins-icon-container">
                                                    <InputLabel >Email Verified</InputLabel>
                                                    <Select
                                                        input={<FilledInput name="active" id="active"
                                                                            type="text"
                                                                            className={`form-control form-control-solid h-2 py-2 px-6`}
                                                                            {...userFormik.getFieldProps("emailVerified")}
                                                        />}
                                                    >
                                                        <MenuItem value={true}>Yes</MenuItem>
                                                        <MenuItem value={false}>No</MenuItem>

                                                    </Select>
                                                    {userFormik.touched.emailVerified && userFormik.errors.emailVerified ? (
                                                        <div className="fv-plugins-message-container">
                                                            <div className="fv-help-block">{userFormik.errors.emailVerified}</div>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </Grid> */}
                                        </Grid>
                                    </Grid>
                                </div>
                            </div>
                        </div>

                        <div className="row justify-content-center mt-3">
                            <button type="submit" className="btn btn-primary mr-3">
                                Save
                            </button>
                            <button type="button" className="btn btn-light" onClick={() => setOpenUserForm(false)}>
                                Cancel
                            </button> 
                        </div>
                    </form>
                </CardBody>
            </Card>
        </>
    );
}

export default injectIntl(EditOrAddUser);
